var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantumCentralCapabilityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 511.59",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #cfdbe3;\n      }\n\n      .cls-3 {\n        fill: #d2dce3;\n      }\n\n      .cls-4 {\n        fill: #f95738;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #001524;\n      }\n\n      .cls-7 {\n        fill: #0174c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Halftone_Circle_Small",
    "data-name": "Halftone Circle Small"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,1.23s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,2.05c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,1.43c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,1.43c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,1.43c.2,0,.41-.2.41-.41s-.2-.41-.41-.41-.41.2-.41.41.2.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,1.43c.2,0,.41-.2.41-.41s-.2-.41-.41-.41-.41.2-.41.41.2.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,1.43c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,1.43c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,1.23s.41,0,.41-.41,0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,1.23s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,25.8c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,26.01c.41,0,.61-.41.61-.61s-.41-.61-.61-.61-.61.41-.61.61.41.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,26.62c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,26.42c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 25.19,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,27.03c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 25.19,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,26.83c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,26.21c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,26.01c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,25.8c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,49.77s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,50.18c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,51.2c.82,0,1.64-.61,1.64-1.64s-.61-1.64-1.64-1.64-1.64.61-1.64,1.64.61,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 146.23,
    cy: 49.56,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,51.81c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,52.43c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,51.61c1.23,0,2.05-1.02,2.05-2.05s-1.02-2.05-2.05-2.05-2.05,1.02-2.05,2.05,1.02,2.05,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 49.56,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,53.04c1.84,0,3.48-1.43,3.48-3.48s-1.43-3.48-3.48-3.48-3.48,1.43-3.48,3.48,1.43,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,51.81c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 49.56,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,52.43c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,51.81c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,50.59c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,50.38c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,50.18c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,49.77s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,74.75c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,75.37c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.86,75.57c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.23,75.78c1.02,0,2.05-.82,2.05-2.05s-.82-2.05-2.05-2.05-2.05.82-2.05,2.05.82,2.05,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,75.98c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,77.82c2.25,0,4.1-1.84,4.1-4.1s-1.84-4.1-4.1-4.1-4.1,1.84-4.1,4.1,1.84,4.1,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,77.62c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,78.64c2.66,0,4.71-2.05,4.71-4.71s-2.05-4.71-4.71-4.71-4.71,2.05-4.71,4.71,2.05,4.71,4.71,4.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 73.93,
    r: 4.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 73.93,
    r: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,78.44c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,77.62c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,75.98c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,75.78c1.02,0,2.05-.82,2.05-2.05s-.82-2.05-2.05-2.05-2.05.82-2.05,2.05.82,2.05,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,75.37c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,74.55c.41,0,.61-.41.61-.61s-.41-.61-.61-.61-.61.41-.61.61.41.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,74.14c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,98.92c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.32,99.53c.82,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.48,100.35c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.86,100.76c1.43,0,2.66-1.23,2.66-2.66s-1.23-2.66-2.66-2.66-2.66,1.23-2.66,2.66,1.23,2.66,2.66,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.23,100.97c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.39,101.17c1.64,0,3.07-1.43,3.07-3.07s-1.43-3.07-3.07-3.07-3.07,1.43-3.07,3.07,1.43,3.07,3.07,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.76,102.6c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 98.1,
    r: 4.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 98.1,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,103.42c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,103.42c2.87,0,5.32-2.25,5.32-5.32s-2.25-5.32-5.32-5.32-5.32,2.25-5.32,5.32,2.25,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 98.1,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,102.6c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,101.58c1.84,0,3.48-1.64,3.48-3.48s-1.64-3.48-3.48-3.48-3.48,1.64-3.48,3.48,1.64,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,101.79c2.05,0,3.48-1.64,3.48-3.48s-1.64-3.48-3.48-3.48-3.48,1.64-3.48,3.48,1.64,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,100.35c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,99.94c1.02,0,1.84-.82,1.84-1.84s-.82-1.84-1.84-1.84-1.84.82-1.84,1.84.82,1.84,1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,99.33c.61,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,98.51c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,122.68s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,123.29c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.32,123.7c.82,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.48,124.72c1.23,0,2.25-1.02,2.25-2.25s-1.02-2.25-2.25-2.25-2.25,1.02-2.25,2.25,1.02,2.25,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.86,126.16c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.23,127.39c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.39,127.8c3.07,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.76,128.61c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 122.47,
    r: 5.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,129.43c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,129.84c4.1,0,7.37-3.28,7.37-7.37s-3.28-7.37-7.37-7.37-7.37,3.28-7.37,7.37,3.28,7.37,7.37,7.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 122.47,
    r: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,129.43c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,128.61c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,126.98c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,127.39c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,125.75c1.84,0,3.48-1.43,3.48-3.48s-1.43-3.48-3.48-3.48-3.48,1.43-3.48,3.48,1.43,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,124.11c1.02,0,1.84-.82,1.84-1.84s-.82-1.84-1.84-1.84-1.84.82-1.84,1.84.82,1.84,1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,123.7c.82,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,122.88c.2,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,122.68s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,147.05s.41,0,.41-.41,0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 48.95,
    cy: 146.84,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.32,149.3c1.43,0,2.46-1.23,2.46-2.46s-1.23-2.46-2.46-2.46-2.46,1.23-2.46,2.46,1.23,2.46,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.48,149.71c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.86,150.32c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.23,151.76c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.39,151.76c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 194.76,
    cy: 146.84,
    r: 7.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,153.8c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.34,
    cy: 146.86,
    r: 8.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,154.21c4.1,0,7.58-3.28,7.58-7.58s-3.28-7.58-7.58-7.58-7.58,3.28-7.58,7.58,3.28,7.58,7.58,7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,154.01c4.1,0,7.37-3.28,7.37-7.37s-3.28-7.37-7.37-7.37-7.37,3.28-7.37,7.37,3.28,7.37,7.37,7.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 146.84,
    r: 7.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.58,
    cy: 146.84,
    r: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,152.17c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,151.76c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,150.32c2.05,0,3.48-1.64,3.48-3.48s-1.64-3.48-3.48-3.48-3.48,1.64-3.48,3.48,1.64,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,149.71c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,148.28c.82,0,1.64-.61,1.64-1.64s-.61-1.64-1.64-1.64-1.64.61-1.64,1.64.61,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 486.2,
    cy: 146.84,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,147.05s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,171.42c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,172.44c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.32,173.88c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.48,173.88c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.86,175.51c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.23,177.15c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.39,177.77c3.69,0,6.55-3.07,6.55-6.55s-3.07-6.55-6.55-6.55-6.55,3.07-6.55,6.55,3.07,6.55,6.55,6.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 194.76,
    cy: 171.01,
    r: 7.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 171.01,
    r: 7.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,179.61c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,180.02c4.92,0,9.01-4.1,9.01-9.01s-4.1-9.01-9.01-9.01-9.01,4.1-9.01,9.01,4.1,9.01,9.01,9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,179.81c4.92,0,8.81-3.89,8.81-8.81s-3.89-8.81-8.81-8.81-8.81,3.89-8.81,8.81,3.89,8.81,8.81,8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,179.61c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.58,
    cy: 171.01,
    r: 7.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.73,
    cy: 171.05,
    r: 6.96,
    transform: "translate(-14.12 308) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,177.15c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,175.51c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 437.66,
    cy: 171.01,
    r: 3.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,172.85c1.02,0,1.84-.82,1.84-1.84s-.82-1.84-1.84-1.84-1.84.82-1.84,1.84.82,1.84,1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,172.44c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,171.42s.41,0,.41-.41,0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.41,195.58s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,195.79c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,197.22c1.02,0,1.84-.82,1.84-1.84s-.82-1.84-1.84-1.84-1.84.82-1.84,1.84.82,1.84,1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,198.45c1.84,0,3.07-1.43,3.07-3.07s-1.43-3.07-3.07-3.07-3.07,1.43-3.07,3.07,1.43,3.07,3.07,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,199.07c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.86,200.5c2.87,0,5.32-2.25,5.32-5.32s-2.25-5.32-5.32-5.32-5.32,2.25-5.32,5.32,2.25,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.23,202.34c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 170.39,
    cy: 195.38,
    r: 7.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.76,203.98c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,203.98c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.34,
    cy: 195.29,
    r: 10.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 195.38,
    r: 10.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.81,
    cy: 195.19,
    r: 10.04,
    transform: "translate(-37.08 72.36) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 195.38,
    r: 9.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.58,
    cy: 195.38,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.76,
    cy: 195.45,
    r: 6.96,
    transform: "translate(-31.37 315.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 389.12,
    cy: 195.38,
    r: 6.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,200.09c2.66,0,4.71-2.05,4.71-4.71s-2.05-4.71-4.71-4.71-4.71,2.05-4.71,4.71,2.05,4.71,4.71,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,199.27c2.25,0,3.89-1.84,3.89-3.89s-1.84-3.89-3.89-3.89-3.89,1.84-3.89,3.89,1.84,3.89,3.89,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,198.25c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,196.81c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,196.4c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 0.41,
    cy: 219.55,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,220.77c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 48.95,
    cy: 219.55,
    r: 1.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 73.32,
    cy: 219.55,
    r: 3.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97.48,
    cy: 219.55,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 121.86,
    cy: 219.55,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,226.51c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 219.55,
    r: 7.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,228.35c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,229.79c5.53,0,10.24-4.51,10.24-10.24s-4.51-10.24-10.24-10.24-10.24,4.51-10.24,10.24,4.51,10.24,10.24,10.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.37,
    cy: 219.43,
    r: 10.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 219.55,
    r: 10.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 219.52,
    r: 10.04,
    transform: "translate(-42.67 73.02) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 219.55,
    r: 9.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,228.35c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,227.53c4.3,0,7.78-3.48,7.78-7.78s-3.48-7.78-7.78-7.78-7.78,3.48-7.78,7.78,3.48,7.78,7.78,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,226.51c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 413.29,
    cy: 219.55,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,223.85c2.25,0,4.1-1.84,4.1-4.1s-1.84-4.1-4.1-4.1-4.1,1.84-4.1,4.1,1.84,4.1,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 462.03,
    cy: 219.55,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,221.18c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,220.57c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 0.41,
    cy: 243.92,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,244.53c.41,0,.61-.41.61-.61s-.41-.61-.61-.61-.61.41-.61.61.41.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,245.56c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,247.4c1.84,0,3.48-1.43,3.48-3.48s-1.43-3.48-3.48-3.48-3.48,1.43-3.48,3.48,1.43,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,248.22c2.46,0,4.3-1.84,4.3-4.3s-1.84-4.3-4.3-4.3-4.3,1.84-4.3,4.3,1.84,4.3,4.3,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,249.24c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,251.29c4.1,0,7.37-3.28,7.37-7.37s-3.28-7.37-7.37-7.37-7.37,3.28-7.37,7.37,3.28,7.37,7.37,7.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 243.92,
    r: 7.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,252.93c4.92,0,9.01-4.1,9.01-9.01s-4.1-9.01-9.01-9.01-9.01,4.1-9.01,9.01,4.1,9.01,9.01,9.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 243.92,
    r: 10.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.23,
    cy: 243.99,
    r: 10.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 243.92,
    r: 10.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 292.01,
    cy: 243.74,
    r: 10.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 243.92,
    r: 10.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,252.93c4.92,0,9.01-4.1,9.01-9.01s-4.1-9.01-9.01-9.01-9.01,4.1-9.01,9.01,4.1,9.01,9.01,9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,252.11c4.51,0,8.19-3.69,8.19-8.19s-3.69-8.19-8.19-8.19-8.19,3.69-8.19,8.19,3.69,8.19,8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,251.29c4.1,0,7.37-3.28,7.37-7.37s-3.28-7.37-7.37-7.37-7.37,3.28-7.37,7.37,3.28,7.37,7.37,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,249.24c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,248.22c2.46,0,4.3-2.05,4.3-4.3s-2.05-4.3-4.3-4.3-4.3,2.05-4.3,4.3,2.05,4.3,4.3,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,247.4c1.84,0,3.48-1.43,3.48-3.48s-1.43-3.48-3.48-3.48-3.48,1.43-3.48,3.48,1.43,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,245.56c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,245.35c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 0.41,
    cy: 268.29,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,269.11c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 48.95,
    cy: 268.29,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,271.56c1.84,0,3.28-1.43,3.28-3.28s-1.43-3.28-3.28-3.28-3.28,1.43-3.28,3.28,1.43,3.28,3.28,3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,273c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,273.61c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 146.23,
    cy: 268.29,
    r: 7.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 268.29,
    r: 7.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 194.76,
    cy: 268.29,
    r: 9.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.78,
    cy: 268.58,
    r: 10.04,
    transform: "translate(-55.92 57.53) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 268.29,
    r: 10.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 268.27,
    r: 10.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 268.29,
    r: 10.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.11,
    cy: 267.96,
    r: 10.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,276.89c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,276.28c4.51,0,8.19-3.69,8.19-8.19s-3.69-8.19-8.19-8.19-8.19,3.69-8.19,8.19,3.69,8.19,8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 389.12,
    cy: 268.29,
    r: 6.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 413.29,
    cy: 268.29,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,272.59c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,271.36c1.84,0,3.28-1.43,3.28-3.28s-1.43-3.28-3.28-3.28-3.28,1.43-3.28,3.28,1.43,3.28,3.28,3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,269.72c.82,0,1.64-.61,1.64-1.64s-.61-1.64-1.64-1.64-1.64.61-1.64,1.64.61,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,268.9c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.41,292.86c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,293.48c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,294.5c1.02,0,2.05-.82,2.05-2.05s-.82-2.05-2.05-2.05-2.05.82-2.05,2.05.82,2.05,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 73.32,
    cy: 292.45,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,296.76c2.25,0,4.1-1.84,4.1-4.1s-1.84-4.1-4.1-4.1-4.1,1.84-4.1,4.1,1.84,4.1,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 121.86,
    cy: 292.45,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,299.42c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,300.24c4.3,0,7.78-3.48,7.78-7.78s-3.48-7.78-7.78-7.78-7.78,3.48-7.78,7.78,3.48,7.78,7.78,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,301.06c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.81,
    cy: 292.71,
    r: 9.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.14,
    cy: 292.63,
    r: 10.04,
    transform: "translate(-60.8 63.78) rotate(-13.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 292.45,
    r: 10.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.61,
    cy: 292.73,
    r: 10.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 292.45,
    r: 9.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,301.06c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,300.24c4.3,0,7.78-3.48,7.78-7.78s-3.48-7.78-7.78-7.78-7.78,3.48-7.78,7.78,3.48,7.78,7.78,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,299.42c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 413.29,
    cy: 292.45,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,296.76c2.25,0,4.1-1.84,4.1-4.1s-1.84-4.1-4.1-4.1-4.1,1.84-4.1,4.1,1.84,4.1,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 462.03,
    cy: 292.45,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,293.89c.82,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,293.48c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,317.24c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,318.26c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,319.69c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,320.51c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,321.33c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,322.97c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 316.83,
    r: 6.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 194.76,
    cy: 316.83,
    r: 7.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 316.83,
    r: 8.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 316.83,
    r: 9.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,325.84c4.92,0,9.01-4.1,9.01-9.01s-4.1-9.01-9.01-9.01-9.01,4.1-9.01,9.01,4.1,9.01,9.01,9.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 316.83,
    r: 9.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,325.43c4.71,0,8.6-3.89,8.6-8.6s-3.89-8.6-8.6-8.6-8.6,3.89-8.6,8.6,3.89,8.6,8.6,8.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.58,
    cy: 316.83,
    r: 7.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,324.2c4.1,0,7.37-3.28,7.37-7.37s-3.28-7.37-7.37-7.37-7.37,3.28-7.37,7.37,3.28,7.37,7.37,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,322.97c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,321.33c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 437.66,
    cy: 316.83,
    r: 3.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,319.69c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,318.26c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,317.64c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,341.81c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 48.95,
    cy: 340.99,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,343.86c1.43,0,2.66-1.23,2.66-2.66s-1.23-2.66-2.66-2.66-2.66,1.23-2.66,2.66,1.23,2.66,2.66,2.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97.48,
    cy: 340.99,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 121.62,
    cy: 341.12,
    r: 3.89,
    transform: "translate(-2.38 .86) rotate(-.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,347.14c3.28,0,5.94-2.66,5.94-5.94s-2.66-5.94-5.94-5.94-5.94,2.66-5.94,5.94,2.66,5.94,5.94,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,347.75c3.69,0,6.55-3.07,6.55-6.55s-3.07-6.55-6.55-6.55-6.55,3.07-6.55,6.55,3.07,6.55,6.55,6.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 194.76,
    cy: 340.99,
    r: 6.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.79,
    cy: 341.12,
    r: 8.4,
    transform: "translate(-7.1 4.66) rotate(-1.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 340.99,
    r: 7.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 340.99,
    r: 9.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.96,
    cy: 340.91,
    r: 8.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,348.16c3.89,0,7.17-3.28,7.17-7.17s-3.28-7.17-7.17-7.17-7.17,3.28-7.17,7.17,3.28,7.17,7.17,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,347.55c3.69,0,6.55-2.87,6.55-6.55s-2.87-6.55-6.55-6.55-6.55,2.87-6.55,6.55,2.87,6.55,6.55,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,347.55c3.48,0,6.35-2.87,6.35-6.35s-2.87-6.35-6.35-6.35-6.35,2.87-6.35,6.35,2.87,6.35,6.35,6.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 389.12,
    cy: 340.99,
    r: 4.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 413.29,
    cy: 340.99,
    r: 3.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,344.68c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 462.03,
    cy: 340.99,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 486.2,
    cy: 340.99,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,341.4s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,365.57s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,366.39c.61,0,1.02-.41,1.02-1.02s-.41-1.02-1.02-1.02-1.02.41-1.02,1.02.41,1.02,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 73.32,
    cy: 365.36,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,368.03c1.43,0,2.66-1.23,2.66-2.66s-1.23-2.66-2.66-2.66-2.66,1.23-2.66,2.66,1.23,2.66,2.66,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,369.05c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,370.28c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 365.36,
    r: 5.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,371.51c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 365.36,
    r: 6.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,372.33c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,372.74c4.1,0,7.37-3.28,7.37-7.37s-3.28-7.37-7.37-7.37-7.37,3.28-7.37,7.37,3.28,7.37,7.37,7.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 365.36,
    r: 7.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,372.33c3.89,0,6.96-3.07,6.96-6.96s-3.07-6.96-6.96-6.96-6.96,3.07-6.96,6.96,3.07,6.96,6.96,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,371.51c3.48,0,6.14-2.87,6.14-6.14s-2.87-6.14-6.14-6.14-6.14,2.87-6.14,6.14,2.87,6.14,6.14,6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,371.1c3.07,0,5.73-2.46,5.73-5.73s-2.46-5.73-5.73-5.73-5.73,2.46-5.73,5.73,2.46,5.73,5.73,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,370.28c2.66,0,4.92-2.25,4.92-4.92s-2.25-4.92-4.92-4.92-4.92,2.25-4.92,4.92,2.25,4.92,4.92,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,369.05c2.05,0,3.48-1.64,3.48-3.48s-1.64-3.48-3.48-3.48-3.48,1.64-3.48,3.48,1.64,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 437.66,
    cy: 365.36,
    r: 3.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,367c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,366.18c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.57,365.57s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,390.55c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,390.96c.61,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,392.19c1.43,0,2.46-1.02,2.46-2.46s-1.02-2.46-2.46-2.46-2.46,1.02-2.46,2.46,1.02,2.46,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,392.4c1.43,0,2.66-1.23,2.66-2.66s-1.23-2.66-2.66-2.66-2.66,1.23-2.66,2.66,1.23,2.66,2.66,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,392.81c1.84,0,3.07-1.43,3.07-3.07s-1.43-3.07-3.07-3.07-3.07,1.43-3.07,3.07,1.43,3.07,3.07,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,393.42c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,394.24c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 389.73,
    r: 6.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 389.73,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,395.06c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,396.08c3.48,0,6.35-2.87,6.35-6.35s-2.87-6.35-6.35-6.35-6.35,2.87-6.35,6.35,2.87,6.35,6.35,6.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 389.73,
    r: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,394.24c2.46,0,4.51-2.05,4.51-4.51s-2.05-4.51-4.51-4.51-4.51,2.05-4.51,4.51,2.05,4.51,4.51,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,394.44c2.66,0,4.71-2.25,4.71-4.71s-2.25-4.71-4.71-4.71-4.71,2.25-4.71,4.71,2.25,4.71,4.71,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,393.42c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,392.4c1.43,0,2.66-1.23,2.66-2.66s-1.23-2.66-2.66-2.66-2.66,1.23-2.66,2.66,1.23,2.66,2.66,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,391.37c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,391.37c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.2,390.55c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,414.31c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.32,414.72c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97.48,
    cy: 413.9,
    r: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 121.86,
    cy: 413.9,
    r: 1.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,416.97c1.64,0,3.07-1.43,3.07-3.07s-1.43-3.07-3.07-3.07-3.07,1.43-3.07,3.07,1.43,3.07,3.07,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,416.77c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 194.76,
    cy: 413.9,
    r: 4.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,418.82c2.66,0,4.71-2.05,4.71-4.71s-2.05-4.71-4.71-4.71-4.71,2.05-4.71,4.71,2.05,4.71,4.71,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,417.79c2.25,0,3.89-1.84,3.89-3.89s-1.84-3.89-3.89-3.89-3.89,1.84-3.89,3.89,1.84,3.89,3.89,3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,419.23c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,419.23c2.87,0,5.32-2.46,5.32-5.32s-2.46-5.32-5.32-5.32-5.32,2.46-5.32,5.32,2.46,5.32,5.32,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,417.59c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.58,
    cy: 413.9,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,416.97c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,416.36c1.23,0,2.46-1.02,2.46-2.46s-1.02-2.46-2.46-2.46-2.46,1.02-2.46,2.46,1.02,2.46,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,415.33c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,414.72c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,414.52c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.95,438.48s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 73.32,
    cy: 438.27,
    r: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,438.89c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,439.91c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,440.32c1.02,0,2.05-.82,2.05-2.05s-.82-2.05-2.05-2.05-2.05.82-2.05,2.05.82,2.05,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 438.27,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,441.14c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,441.34c1.64,0,3.07-1.43,3.07-3.07s-1.43-3.07-3.07-3.07-3.07,1.43-3.07,3.07,1.43,3.07,3.07,3.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 438.27,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,441.75c1.84,0,3.48-1.43,3.48-3.48s-1.43-3.48-3.48-3.48-3.48,1.43-3.48,3.48,1.43,3.48,3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,441.96c2.05,0,3.69-1.64,3.69-3.69s-1.64-3.69-3.69-3.69-3.69,1.64-3.69,3.69,1.64,3.69,3.69,3.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 316.21,
    cy: 438.27,
    r: 3.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,441.14c1.64,0,2.87-1.23,2.87-2.87s-1.23-2.87-2.87-2.87-2.87,1.23-2.87,2.87,1.23,2.87,2.87,2.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.75,
    cy: 438.27,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,440.32c1.02,0,2.05-.82,2.05-2.05s-.82-2.05-2.05-2.05-2.05.82-2.05,2.05.82,2.05,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,439.09c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,438.89c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.03,438.48s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.48,463.26c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.86,463.26c.41,0,.61-.41.61-.61s-.41-.61-.61-.61-.61.41-.61.61.41.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,463.46c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.39,
    cy: 462.64,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,463.87c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 218.93,
    cy: 462.64,
    r: 2.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 243.3,
    cy: 462.64,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.67,464.28c1.02,0,1.64-.82,1.64-1.64s-.82-1.64-1.64-1.64-1.64.82-1.64,1.64.82,1.64,1.64,1.64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 291.84,
    cy: 462.64,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,464.49c1.02,0,1.84-.82,1.84-1.84s-.82-1.84-1.84-1.84-1.84.82-1.84,1.84.82,1.84,1.84,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,463.87c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 364.75,
    cy: 462.64,
    r: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,463.26c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.29,463.26c.41,0,.61-.41.61-.61s-.41-.61-.61-.61-.61.41-.61.61.41.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.66,463.26c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.23,487.42c.41,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.39,487.63c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,488.04c.61,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,488.24c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,488.45c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 486.81,
    r: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,488.24c.82,0,1.43-.61,1.43-1.43s-.61-1.43-1.43-1.43-1.43.61-1.43,1.43.61,1.43,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,488.24c.82,0,1.23-.61,1.23-1.23s-.61-1.23-1.23-1.23-1.23.61-1.23,1.23.61,1.23,1.23,1.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 340.58,
    cy: 486.81,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,487.63c.41,0,.82-.41.82-.82s-.41-.82-.82-.82-.82.41-.82.82.41.82.82.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.12,487.01s.2,0,.2-.2,0-.2-.2-.2-.2,0-.2.2,0,.2.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.76,511.59c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.93,511.59c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.3,511.59c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 267.67,
    cy: 511.18,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M291.84,511.59c.2,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.21,511.59c.2,0,.61-.2.61-.61s-.2-.61-.61-.61-.61.2-.61.61.2.61.61.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.58,511.59c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.75,511.59c.2,0,.41,0,.41-.41s0-.41-.41-.41-.41,0-.41.41,0,.41.41.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.34,404.59c-7.19-9.75-27.2-32.39-57.66-32.45h-.03c-.35,0-.69,0-1.04.01-30,.46-49.59,22.77-56.67,32.42-1.17,1.59-1.75,3.46-1.75,5.33,0,2.04.7,4.07,2.08,5.73,7.73,9.33,28.78,31.02,57.29,31.02h.09c.4,0,.8-.01,1.18-.02h.05c27.84-.65,48.47-21.77,56.12-30.94,2.67-3.18,2.81-7.75.34-11.1ZM160.1,411.6c-3.96,4.74-11.66,12.96-22.1,19.38-8.48,5.21-18.76,9.25-30.31,9.28h-.13c-12.9,0-24.21-5.02-33.18-11.12-8.98-6.1-15.63-13.28-19.2-17.6-.75-.92-.8-2.23-.09-3.19,3.8-5.17,11.49-14.3,22.62-21.11,8.15-4.98,18.17-8.71,29.85-8.71h.09c27.57.05,45.93,20.88,52.55,29.85.71.97.67,2.29-.1,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160.2,408.39c-6.62-8.97-24.98-29.8-52.55-29.85h-.09c-16.98.05-30.77,13.87-30.77,30.86,0,1.76-1.44,3.2-3.2,3.2s-3.19-1.44-3.19-3.2c0-8.29,2.72-15.96,7.31-22.15-11.13,6.8-18.82,15.94-22.62,21.11-.7.96-.66,2.27.09,3.19,3.57,4.32,10.22,11.5,19.2,17.6,8.97,6.1,20.28,11.12,33.18,11.12h.13c17-.02,30.82-13.86,30.82-30.87,0-1.76,1.43-3.19,3.19-3.19s3.2,1.43,3.2,3.19c0,8.04-2.55,15.5-6.91,21.59,10.44-6.43,18.14-14.64,22.1-19.38.78-.93.82-2.24.1-3.21ZM126.8,410.51c-.56,9.79-8.82,17.8-18.64,18.07-11.87.31-21.4-10.19-19.43-22.37,1.18-7.34,6.76-13.42,13.95-15.32,3.05-.82,6-.84,8.73-.29,1.51.32,2.31,1.91,1.93,3.41-.33,1.29-.33,2.7.11,4.16.69,2.38,2.63,4.29,5,5.01,1.57.48,3.08.45,4.43.06,1.49-.44,3.11.32,3.46,1.83.41,1.73.57,3.57.47,5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.91,409.4c0,8.04-2.55,15.5-6.91,21.59-6.54,9.16-17.12,15.26-29.12,15.65h-.05c-.39.01-.79.02-1.18.02h-.02c-1.75-.01-3.18-1.44-3.18-3.19s1.44-3.19,3.2-3.19h.04c17-.02,30.82-13.86,30.82-30.87,0-1.76,1.43-3.19,3.19-3.19s3.2,1.43,3.2,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.85,375.34c0,1.76-1.43,3.19-3.19,3.19h-.09c-16.98.05-30.77,13.87-30.77,30.86,0,1.76-1.44,3.2-3.2,3.2s-3.19-1.44-3.19-3.2c0-8.29,2.72-15.96,7.31-22.15,6.61-8.91,17.08-14.77,28.9-15.1.35-.01.69-.01,1.04-.01h.03c1.75.02,3.16,1.45,3.16,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.8,410.51c-.56,9.79-8.82,17.8-18.64,18.07-11.87.31-21.4-10.19-19.43-22.37,1.18-7.34,6.76-13.42,13.95-15.32,3.05-.82,6-.84,8.73-.29,1.51.32,2.31,1.91,1.93,3.41-.33,1.29-.33,2.7.11,4.16.69,2.38,2.63,4.29,5,5.01,1.57.48,3.08.45,4.43.06,1.49-.44,3.11.32,3.46,1.83.41,1.73.57,3.57.47,5.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 414.72,
    cy: 134.35,
    r: 51.65
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cryptography_Binaries",
    "data-name": "Cryptography, Binaries"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.66,131.33h-6.02c-2.7,0-4.89-2.19-4.89-4.89v-12.03c0-2.7,2.19-4.89,4.89-4.89h6.02c2.7,0,4.89,2.19,4.89,4.89v12.03c0,2.7-2.19,4.89-4.89,4.89ZM387.65,113.28c-.62,0-1.13.51-1.13,1.13v12.03c0,.62.51,1.13,1.13,1.13h6.02c.62,0,1.13-.51,1.13-1.13v-12.03c0-.62-.51-1.13-1.13-1.13,0,0-6.02,0-6.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.7,131.33c-1.04,0-1.88-.84-1.88-1.88v-18.05c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.05c0,1.04-.84,1.88-1.88,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420.74,131.33c-1.04,0-1.88-.84-1.88-1.88v-18.05c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.05c0,1.04-.84,1.88-1.88,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M441.79,131.33h-6.02c-2.7,0-4.89-2.19-4.89-4.89v-12.03c0-2.7,2.19-4.89,4.89-4.89h6.02c2.7,0,4.89,2.19,4.89,4.89v12.03c0,2.7-2.19,4.89-4.89,4.89ZM435.78,113.28c-.62,0-1.13.51-1.13,1.13v12.03c0,.62.51,1.13,1.13,1.13h6.02c.62,0,1.13-.51,1.13-1.13v-12.03c0-.62-.51-1.13-1.13-1.13,0,0-6.02,0-6.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M384.64,159.17c-1.04,0-1.88-.84-1.88-1.88v-18.05c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.05c0,1.04-.84,1.88-1.88,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M396.67,159.17c-1.04,0-1.88-.84-1.88-1.88v-18.05c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.05c0,1.04-.84,1.88-1.88,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.15,159.17h-6.02c-2.7,0-4.89-2.19-4.89-4.89v-12.03c0-2.7,2.19-4.89,4.89-4.89h6.02c2.7,0,4.89,2.19,4.89,4.89v12.03c0,2.7-2.19,4.89-4.89,4.89ZM411.13,141.13c-.62,0-1.13.51-1.13,1.13v12.03c0,.62.51,1.13,1.13,1.13h6.02c.62,0,1.13-.51,1.13-1.13v-12.03c0-.62-.51-1.13-1.13-1.13h-6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432.77,159.17c-1.04,0-1.88-.84-1.88-1.88v-18.05c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.05c0,1.04-.84,1.88-1.88,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M444.8,159.17c-1.04,0-1.88-.84-1.88-1.88v-18.05c0-1.04.84-1.88,1.88-1.88s1.88.84,1.88,1.88v18.05c0,1.04-.84,1.88-1.88,1.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Quantum_PQC",
    "data-name": "Quantum, PQC"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.24,170.37c-1.81,0-3.45-1.22-3.92-3.06-2.59-10.29-3.9-21.38-3.9-32.96,0-42.18,17.41-75.21,39.63-75.21,8.85,0,17.15,5.18,24,14.98,1.28,1.83.83,4.35-1,5.63-1.83,1.28-4.35.83-5.63-1-3.68-5.26-9.67-11.53-17.37-11.53-17.1,0-31.54,30.74-31.54,67.12,0,10.91,1.23,21.34,3.66,30.99.55,2.16-.77,4.36-2.93,4.91-.33.08-.66.12-.99.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.05,209.56c-8.76,0-16.99-5.08-23.79-14.68-1.29-1.82-.86-4.35.96-5.64,1.82-1.28,4.34-.86,5.64.96,3.64,5.14,9.58,11.27,17.19,11.27,10.63,0,20.87-12.25,26.73-31.96.63-2.14,2.89-3.35,5.03-2.72,2.14.64,3.36,2.89,2.72,5.03-7.03,23.63-19.92,37.74-34.48,37.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.61,185.08c-2.01,0-3.76-1.5-4-3.55-.27-2.22,1.3-4.23,3.52-4.51,5.79-.71,13.44-2.87,17.05-9.11,3.84-6.65,1.43-14.95-1.27-20.75-.94-2.03-.07-4.43,1.95-5.37,2.03-.95,4.43-.07,5.37,1.95,5.04,10.8,5.36,20.56.94,28.21-4.17,7.22-12.14,11.76-23.06,13.09-.17.02-.34.03-.5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.68,127.87c-1.03,0-2.07-.39-2.86-1.18-7.23-7.21-16.23-14.01-26.01-19.66-9.81-5.66-20.23-10.06-30.12-12.72-2.16-.58-3.44-2.8-2.86-4.95.58-2.16,2.8-3.44,4.95-2.86,10.57,2.84,21.65,7.52,32.07,13.53,10.37,5.99,19.94,13.23,27.67,20.93,1.58,1.58,1.59,4.14,0,5.72-.79.79-1.83,1.19-2.87,1.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.66,125.33c-1.59,0-3.09-.94-3.74-2.5-4.11-9.95-4.11-18.97,0-26.08,4.02-6.96,11.62-11.44,21.97-12.95,2.16-.31,4.26,1.21,4.58,3.42.32,2.21-1.21,4.26-3.42,4.58-5.45.79-12.66,3-16.13,8.99-3.54,6.13-1.69,13.69.48,18.95.85,2.07-.13,4.43-2.19,5.28-.5.21-1.03.31-1.55.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.16,185.57c-4.78,0-9.23-.52-13.25-1.59-7.8-2.09-13.68-6.24-17.01-12.03-7.21-12.54-1.55-30.63,15.14-48.4,1.53-1.63,4.09-1.71,5.72-.18,1.63,1.53,1.71,4.09.18,5.72-13.9,14.81-19.27,29.69-14.02,38.83,2.26,3.93,6.32,6.71,12.08,8.24,15.36,4.11,39.63-1.58,61.8-14.49,31.45-18.31,50.86-46.19,42.37-60.88-4.89-8.47-18.55-11.51-36.54-8.14-2.21.42-4.31-1.04-4.72-3.23-.41-2.2,1.03-4.31,3.23-4.72,21.83-4.09,38.25.29,45.03,12.04,11.04,19.11-8.86,50.7-45.3,71.91-18.76,10.92-38.56,16.91-54.71,16.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.05,154.57c-11.15,0-20.22-9.07-20.22-20.22s9.07-20.22,20.22-20.22,20.22,9.07,20.22,20.22-9.07,20.22-20.22,20.22ZM138.05,122.22c-6.69,0-12.13,5.44-12.13,12.13s5.44,12.13,12.13,12.13,12.13-5.44,12.13-12.13-5.44-12.13-12.13-12.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M346.1,286.18v-152.32h-78.66v-16.97h-33.04v16.97h-81.01v247.46h142.59c10.37,11.03,25.08,17.92,41.41,17.92,31.4,0,56.86-25.46,56.86-56.86,0-28.44-20.88-52-48.15-56.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compliance"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.67,369.19h83.94c4.2,0,7.6,3.4,7.6,7.6h0c0,4.2-3.4,7.6-7.6,7.6h-83.94c-17.9,0-32.48-14.57-32.48-32.48v-199.06c0-17.73,14.28-32.18,31.92-32.48,4.21-.07,7.95,3.02,8.15,7.23s-3.27,7.97-7.59,7.97c-9.52,0-17.28,7.75-17.28,17.28v199.06c0,9.52,7.75,17.28,17.28,17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.45,152.84v98.74c0,4.2-3.4,7.6-7.6,7.6h0c-4.2,0-7.6-3.4-7.6-7.6v-98.74c0-9.48-7.67-17.2-17.13-17.28-3.93-.04-7.36-2.97-7.72-6.89-.41-4.52,3.13-8.31,7.56-8.31,17.91,0,32.48,14.57,32.48,32.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.44,120.2h-6.03c-3.33-10.7-13.34-18.51-25.08-18.51s-21.75,7.8-25.08,18.51h-6.03c-11.06,0-20.04,8.99-20.04,20.04v12.44c0,11.05,8.98,20.04,20.04,20.04h62.22c11.05,0,20.04-8.99,20.04-20.04v-12.44c0-11.05-8.99-20.04-20.04-20.04ZM281.26,152.68c0,2.68-2.16,4.85-4.83,4.85h-62.21c-2.68,0-4.85-2.17-4.85-4.85v-12.43c0-2.68,2.18-4.85,4.85-4.85h20l.06-7.54c.05-6.05,5.01-10.97,11.05-10.97s11,4.92,11.05,10.97l.07,7.54h20c2.67,0,4.83,2.17,4.83,4.85v12.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M212.63,234.45h-21.91c-6.8,0-12.32-5.53-12.32-12.32v-21.91c0-6.79,5.53-12.32,12.32-12.32h21.91c6.8,0,12.32,5.53,12.32,12.32v21.91c0,6.79-5.53,12.32-12.32,12.32ZM192.09,220.76h19.17v-19.17h-19.17v19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.41,218.02h-54.77c-3.78,0-6.85-3.07-6.85-6.85s3.07-6.85,6.85-6.85h54.77c3.78,0,6.85,3.07,6.85,6.85s-3.07,6.85-6.85,6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M212.63,294.21h-21.91c-6.8,0-12.32-5.53-12.32-12.32v-21.91c0-6.79,5.53-12.32,12.32-12.32h21.91c6.8,0,12.32,5.53,12.32,12.32v21.91c0,6.79-5.53,12.32-12.32,12.32ZM192.09,280.52h19.17v-19.17h-19.17v19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M284.64,277.78h-36.01c-3.78,0-6.85-3.07-6.85-6.85s3.07-6.85,6.85-6.85h36.01c3.78,0,6.85,3.07,6.85,6.85s-3.07,6.85-6.85,6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M212.63,353.96h-21.91c-6.8,0-12.32-5.53-12.32-12.32v-21.91c0-6.79,5.53-12.32,12.32-12.32h21.91c6.8,0,12.32,5.53,12.32,12.32v21.91c0,6.79-5.53,12.32-12.32,12.32ZM192.09,340.27h19.17v-19.17h-19.17v19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.85,337.53h-19.21c-3.78,0-6.85-3.07-6.85-6.85s3.07-6.85,6.85-6.85h19.21c3.78,0,6.85,3.07,6.85,6.85s-3.07,6.85-6.85,6.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search_-_relevance",
    "data-name": "Search - relevance"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M424.61,420.57l-36.3-36.3c10.36-12.55,16-28.16,16-44.64,0-18.77-7.31-36.42-20.59-49.69-27.39-27.39-71.97-27.39-99.37,0-13.27,13.27-20.58,30.92-20.58,49.69s7.31,36.41,20.58,49.68c13.25,13.26,30.9,20.55,49.69,20.55,16.49,0,32.11-5.62,44.64-15.97l36.3,36.31c1.28,1.28,2.99,1.99,4.81,1.99s3.53-.71,4.82-2c2.65-2.65,2.65-6.97,0-9.62ZM374.15,379.64s-.04.03-.05.05l-.05.05c-10.68,10.65-24.88,16.52-40.01,16.52-7.58,0-14.92-1.47-21.71-4.28-6.78-2.81-13.01-6.95-18.35-12.29-10.7-10.7-16.6-24.92-16.6-40.06s5.9-29.36,16.6-40.06c10.68-10.69,24.91-16.57,40.06-16.57s29.38,5.88,40.06,16.57c10.7,10.7,16.6,24.93,16.6,40.06s-5.88,29.31-16.55,40.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.65,339.63c0,15.89-6.19,30.83-17.41,42.09-.02.02-.04.03-.05.05l-.05.05c-11.23,11.2-26.17,17.38-42.09,17.38-7.97,0-15.7-1.55-22.84-4.5-7.13-2.96-13.69-7.31-19.3-12.93-11.26-11.26-17.46-26.21-17.46-42.14s6.21-30.88,17.46-42.14c11.23-11.25,26.2-17.43,42.14-17.43s30.91,6.19,42.14,17.43c11.26,11.26,17.46,26.23,17.46,42.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.26,357.43c-1.09,0-2.17-.41-3-1.24-1.65-1.65-1.65-4.34,0-6l27.13-27.13c1.65-1.65,4.34-1.65,6,0,1.66,1.65,1.65,4.34,0,6l-27.13,27.13c-.83.83-1.91,1.24-3,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.26,357.43c-1.09,0-2.17-.41-3-1.24l-13.56-13.56c-1.65-1.65-1.65-4.34,0-6s4.34-1.65,6,0l13.56,13.56c1.65,1.65,1.65,4.34,0,6-.83.83-1.91,1.24-3,1.24Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantumCentralCapabilityImage);
export default __webpack_public_path__ + "static/media/quantum-central-capability-image.b19e7bcf.svg";
export { ForwardRef as ReactComponent };